import Vue from "vue"
import Router from "vue-router"

import eventRoutes from "@/views/event/router"

Vue.use(Router)

let router = new Router({
	mode: "history",
	routes: [
		{
			path: "/login",
			name: "Login",
			component: () => import(/* webpackChunkName: "Dashboard" */ "@/views/Login")
		},
		{
			path: "/logout",
			name: "Logout",
			component: () => import(/* webpackChunkName: "Dashboard" */ "@/views/Logout")
		},

		{
			path: "/",
			name: "Dashboard",
			meta: {
				requiresAuth: true
			},
			component: () => import(/* webpackChunkName: "Dashboard" */ "@/views/Dashboard")
		},
		...eventRoutes,

		{
			path: "*",
			redirect: "/"
		}
	]
})

// router.beforeEach((to, from, next) => {
//   var loggedIn = localStorage.getItem('logged-app');
//   loggedIn = JSON.parse(loggedIn)
//   if(to.matched.some(record => record.meta.requiresAuth)) {
//     if (loggedIn  ) {
//       next()
//       return
//     }
//     next('/login')
//   } else {
//     next()
//   }
// })

export default router
